import React, { CSSProperties } from 'react';

import { useHistory } from 'react-router';

import Chat from 'components/Icons/Chat';

import './ChatButton.scoped.scss';

interface Props {
  style?: CSSProperties;
}

const ChatButton: React.FC<Props> = ({ style }) => {
  const history = useHistory();

  const redirectToChat = () => {
    if (history.location.pathname.includes('/chat')) return;

    history.push('/chat');
  };

  return (
    <div className="chat-icon-container pointer" style={style} onClick={redirectToChat}>
      <Chat color="var(--colour-secondary)" fontSize="1.3em" />
    </div>
  );
};

export default ChatButton;
